import { render, staticRenderFns } from "./PixCard.vue?vue&type=template&id=3b0b9b2c&"
import script from "./PixCard.vue?vue&type=script&lang=js&"
export * from "./PixCard.vue?vue&type=script&lang=js&"
import style0 from "./PixCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0b9b2c')) {
      api.createRecord('3b0b9b2c', component.options)
    } else {
      api.reload('3b0b9b2c', component.options)
    }
    module.hot.accept("./PixCard.vue?vue&type=template&id=3b0b9b2c&", function () {
      api.rerender('3b0b9b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/paymentLink/PixCard.vue"
export default component.exports